<template>
    <div @click="onEventClick" :class="['client-wrapper', {'dark': currentEvent && currentEvent.id === event.id}]">
        <template  v-if="event.client">

            <v-subheader class="client-title ">
                <v-chip small outline color="primary">
                    <v-icon size="15" class="mr-2">fa-clock</v-icon>
                    {{event.time}}
                </v-chip>
                <event-status-chip v-if="event.event_status" :event-status="event.event_status" />
                <v-tooltip top v-if="event.extra">
                    <template v-slot:activator="{ on }">
                        <v-avatar color="blue-grey  ml-1" size="25">
                            <v-icon color="white" size="13" dark v-on="on">fas fa-calendar-plus</v-icon>
                        </v-avatar>
                    </template>
                    <span>Cupo extra</span>
                </v-tooltip>
                <v-tooltip top v-if="event.type === 'video'">
                    <template v-slot:activator="{ on }">
                        <v-avatar color="black  ml-1" size="25">
                            <v-icon color="white" size="13" dark v-on="on">fas fa-video</v-icon>
                        </v-avatar>
                    </template>
                    <span>Video Llamada</span>
                </v-tooltip>
                <v-spacer></v-spacer>
            </v-subheader>

            <v-list-tile avatar>

                <v-icon
                        v-if="currentEvent && currentEvent.id === event.id"
                        size="12"
                        class="mr-2"
                        color="accent">fa-circle</v-icon>

                <v-list-tile-avatar size="45">
                    <img :src="event.client && event.client.avatar || getFakeAvatar(event.client.gender)">
                </v-list-tile-avatar>


                <v-list-tile-content>
                    <v-list-tile-title>{{event.client.first_name}} {{event.client.last_name || ''}}</v-list-tile-title>
                    <v-list-tile-sub-title>{{details}}</v-list-tile-sub-title>
                </v-list-tile-content>

            </v-list-tile>

        </template>

        <template v-else>
            <v-subheader class="client-title ">
                <v-chip small outline color="primary">
                    <v-icon size="15" class="mr-2">fa-clock</v-icon>
                    {{event.time}}
                </v-chip>
                <v-chip small readonly outline color="red">
                    <v-icon size="15" class="mr-2">fa-ban</v-icon>
                    Cancelada
                </v-chip>
                <v-tooltip top v-if="event.extra">
                    <template v-slot:activator="{ on }">
                        <v-avatar color="blue-grey  ml-1" size="25">
                            <v-icon color="white" size="13" dark v-on="on">fas fa-calendar-plus</v-icon>
                        </v-avatar>
                    </template>
                    <span>Cupo extra</span>
                </v-tooltip>
                <v-tooltip top v-if="event.type === 'video'">
                    <template v-slot:activator="{ on }">
                        <v-avatar color="black  ml-1" size="25">
                            <v-icon color="white" size="13" dark v-on="on">fas fa-video</v-icon>
                        </v-avatar>
                    </template>
                    <span>Video Llamada</span>
                </v-tooltip>
            </v-subheader>

            <v-list-tile avatar v-if="lastCancelledEvent.client">

                <v-icon
                        v-if="currentEvent && currentEvent.id === event.id"
                        size="12"
                        class="mr-2"
                        color="accent">fa-circle</v-icon>

                <v-list-tile-avatar size="45">
                    <img :src="lastCancelledEvent.client.avatar || getFakeAvatar(lastCancelledEvent.client.gender)">
                </v-list-tile-avatar>


                <v-list-tile-content>
                    <v-list-tile-title>{{lastCancelledEvent.client.first_name}} {{lastCancelledEvent.client.last_name || ''}}</v-list-tile-title>
                    <v-list-tile-sub-title>{{details}}</v-list-tile-sub-title>
                </v-list-tile-content>

            </v-list-tile>
        </template>

    </div>
</template>

<script>

    import EventStatusChip from '@/components/appointments/EventStatusChip'
    import {getFakeAvatar} from '@/utils/Common'
    import {getEventCancelReason} from '@/utils/Strings'

    import {mapState} from 'vuex'

    export default{
        props: ['event'],
        components: {EventStatusChip},
        mounted(){
            var vm = this
            vm.setArrivedAtInterval()
        },
        data(){
            return {
                arrivedAt: null,
                arrivedAtInterval: null
            }
        },
        methods: {
            getFakeAvatar,
            onEventClick(){
                var vm = this
                if(!vm.event || !vm.event.client) return
                vm.$emit('click:appointment', vm.event)

            },
            setArrivedAtInterval(){
                var vm = this
                if(vm.event && vm.event.event_status.id === 3 && vm.event.arrived_at){

                    vm.arrivedAtInverval = setInterval(function(){
                        const diff = vm.$moment().diff(vm.$moment(vm.event.arrived_at))
                        const duration = vm.$moment.duration(diff)
                        if(duration.hours() === 0 && duration.minutes() === 0){
                            var humanized = 'Llegó hace unos segundos'
                        }else{

                            var hoursForHumans = duration.hours() > 0 ? `${duration.hours()} hora${duration.hours() > 1 ? 's' : ''}` : ''
                            var minutesForHumans =  duration.minutes() > 0 ? `${duration.minutes()} minuto${duration.minutes() > 1 ? 's' : ''}` : ''

                            if(hoursForHumans && minutesForHumans){
                                var humanized =  `Llegó hace ${hoursForHumans} y ${minutesForHumans}`
                            }else{
                                var humanized = hoursForHumans ? `Llegó hace ${hoursForHumans}` : `Llegó hace ${minutesForHumans}`
                            }

                        }

                        vm.arrivedAt = humanized
                    }, 1000)

                }
            }
        },
        computed: {
            ...mapState('clientAttention', {
                currentEvent: state => state.currentEvent
            }),
            lastCancelledEvent(){
                var vm = this
                if(
                        !vm.event.cancelled_events ||
                        vm.event.cancelled_events.length === 0 ||
                        !vm.event.cancelled_events[0].client
                ){
                    return null
                }

                const sorted = vm.event.cancelled_events.filter(evt => evt.client)
                .sort((a,b) => {
                    return b.id - a.id
                })

                var lastCancelledEvents = sorted[0]
                lastCancelledEvents.reason = getEventCancelReason(lastCancelledEvents.reason)

                return sorted[0]

            },

            details(){
                var vm = this
                const event = vm.event

                if(!event.client && vm.lastCancelledEvent){
                    return getEventCancelReason(vm.lastCancelledEvent.reason)
                }

                if(event.event_status.id === 3 && event.arrived_at){
                    return `${vm.arrivedAt || '-'}`
                }


            }

        },
        watch: {
            event(val){
                var vm = this

                clearInterval(vm.arrivedAtInterval)
                vm.setArrivedAtInterval()
            }
        }
    }
</script>

<style scoped>

    .client-title{
        height: 10px;
        margin-top: 20px;
    }

    .client-wrapper{
        transition: all .2s;
    }

    .client-wrapper:hover{
        transform: scale(1.03);
        cursor: pointer;
    }


</style>